import script from "./CinqueTerreGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./CinqueTerreGuide.vue?vue&type=script&lang=ts&setup=true"

import "./CinqueTerreGuide.vue?vue&type=style&index=0&id=59c238ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59c238ae"]])

export default __exports__